export enum AUTOLOG_STATUS {
	SUCCESS = 'success',
	FAIL = 'fail',
}

export type AppName = 'Deezer' | 'Zen' | 'Shaker' | 'Games' | 'MyDeezerYear';
